import {
  GET_APPEL_EMETTRE,
  GET_APPEL_EMETTRE_BY_CONTACT,
  ADD_APPEL_EMETTRE,
  DELETE_APPEL_EMETTRE,
  DELETE_APPEL_EMETTRE_BY_CONTACT,
  GET_ETAPES,
  UPDATE_ETAPE,
  UPDATE_APPEL_EMETTRE,
  UPDATE_TIME_APPEL_EMETTRE,
  UPDATE_TIME_BULK_APPEL_EMETTRE,
  UPDATE_TIME_BULK_APPEL_EMETTRE_AGENDA,
  UPDATE_DATE_APPEL_EMETTRE,
  UPDATE_APPEL_EMETTRE_BY_CONTACT,
  GET_ACTIVITES,
  GET_CALLS,
  GET_CALL_ENDED,
  GET_CALLS_CHIP,
  GET_CALLS_CHIP_COUNTS,
  GET_CONTACTS,
  GET_CONTACTS_NOT_AFFECTED,
  GET_CONTACTS_NOT_AFFECTED_ALARME,
  GET_CONTACTS_NOT_AFFECTED_MOBILE,
  GET_VENTES,
  GET_CONTACTS_SOUS_CONTRAT_BY_ID,
  ADD_NOTE,
  GET_NOTES,
  UPDATE_NOTE,
  DELETE_NOTE,
  GET_VENTE_BY_ID,
  GET_PIPELINE_CONTACT,
  GET_PIPELINE_CONTACT_BY_USER,
  GET_PIPELINE_CONTACT_MOBILE,
  GET_PIPELINE_CONTACT_MOBILE_BY_USER,
  MODIFY_STATUT_PIPELINE,
  MODIFY_STATUT_PIPELINE_MOBILE,
  GET_AFFECTED_CONTACTS,
  GET_AFFECTED_CONTACTS_ALARME,
  GET_AFFECTED_CONTACTS_MOBILE,
  GET_PIPELINE_CONTACT_AFFECTED,
  GET_PIPELINE_CONTACT_AFFECTED_BY_USER,
  GET_PIPELINE_CONTACT_AFFECTED_MOBILE,
  GET_PIPELINE_CONTACT_AFFECTED_MOBILE_BY_USER,
  GET_CALL_ID,
  UPDATE_APPEL_EMETTRE_NOTIFIED,
  GET_RH_TIMELINE,
  UPLOAD_CONTACTS,
  GET_RDV,
  GET_RDV_BY_CONTACT,
  UPDATE_RDV_BY_USER,
  UPDATE_RDV_BY_CONTACT,
  UPDATE_TIME_RDV,
  UPDATE_TIME_BULK_RDV,
  UPDATE_TIME_BULK_RDV_AGENDA,
  GET_RDV_AFFECTED_TO_USER,
  GET_RDV_CREATED_BY_USER,
  ADD_RDV,
  ACCEPT_AFFECTED_CONTACT,
  GET_CALLS_FOR_DISPLAY,
  GET_SALES_FOR_DISPLAY,
  GET_RDV_FOR_DISPLAY,
  GET_AGENDA_INSTALLATION,
  GET_RESEARCH_JOURNAL,
  GET_DEMANDE_AFFECTAION,
  UPDATE_DEMANDE_AFFECTAION,
  GET_SOUS_CONTRAT,
  GET_FUTURE_ECHEANCE,
  GET_FUTURE_BESOIN,
  GET_HORS_CIBLE,
  GET_SOUS_CONTRAT_ALARME,
  GET_FUTURE_ECHEANCE_ALARME,
  GET_FUTURE_BESOIN_ALARME,
  GET_KO_BUDGET_ALARME,
  GET_KO_AUTORITE_ALARME,
  GET_KO_REFUS_ALARME,
  GET_PAS_INTERESSE_ALARME,
  GET_KO_AUTRE_ALARME,
  GET_KO_BUDGET_MOBILE,
  GET_KO_AUTORITE_MOBILE,
  GET_KO_REFUS_MOBILE,
  GET_PAS_INTERESSE_MOBILE,
  GET_KO_AUTRE_MOBILE,
  GET_SOUS_CONTRAT_MOBILE,
  GET_FUTURE_ECHEANCE_MOBILE,
  GET_FUTURE_BESOIN_MOBILE,
  GET_CONTACTS_HORSCIRCUIT_ALARME,
  UPDATE_CONTACTS_HORSCIRCUIT_ALARME,
  MERGE_CONTACTS_HORS_CIRCUIT,
  UPDATE_CONTACT,

} from "../actions/types";

const initialState = {
  callEnded: {},
  suivis: [],
  ventes: { ventes: [] },
  contactsHorsCircuit: [],
  contactsHorsCircuitSearch: null,
  appelsEmettre: [],
  rdvByUser: [],
  rdvByContact: [],
  rdvCreatedByUser: [],
  appelsEmettreByContact: [],
  appelAEmettresOutDated: [],
  appelAEmettresToDay: [],
  appelAEmettresToMorrow: [],
  appelAEmettresTwoDays: [],
  appelAEmettresThreeDays: [],
  appelAEmettresFourDays: [],
  appelAEmettresFiveDays: [],
  appelAEmettresOneMonth: [],
  appelAEmettresSixMonth: [],

  appelAEmettresAboveFiveDays: [],
  appelAEmettresAssignedCategorised: [],
  appelAEmettresAssigned: [],
  rdvCree: [],
  failedUpload: [],
  RHTimeline: [],
  etapes: [],
  activites: [],
  calls: { call: [] },
  updatedCall: {},
  callsChip: { calls: [] },
  statutsAppelEmettre: [],
  contactsSousContrat: [],
  sousContrat: [],
  contacts: { contacts: [] },
  contactsNotAffected: [],
  contactsNotAffectedAlarme: [],
  contactsNotAffectedMobile: [],
  affectedContacts: [],
  affectedContactsAlarme: [],
  affectedContactsMobile: [],
  notesDynamiques: [],
  venteByID: {},
  pipelineLeads: [],
  pipelineLeadsMobile: [],

  sContrat: [],
  futureEcheance: [],
  futureBesoin: [],
  horsCible: [],

  sContratAlarme: [],
  futureEcheanceAlarme: [],
  futureBesoinAlarme: [],
  koBudgetAlarme: [],
  koAutoriteAlarme: [],
  koRefusAlarme: [],
  pasInteresseAlarme: [],
  koAutreAlarme: [],

  sContratMobile: [],
  futureEcheanceMobile: [],
  futureBesoinMobile: [],
  koBudgetMobile: [],
  koAutoriteMobile: [],
  koRefusMobile: [],
  pasInteresseMobile: [],
  koAutreMobile: [],

  pipelineLeadsAffected: [],
  pipelineLeadsAffectedMobile: [],

  rdvsOutDated: [],
  rdvsToDay: [],
  rdvsToMorrow: [],
  rdvsTwoDays: [],
  rdvsThreeDays: [],
  rdvsFourDays: [],
  rdvsFiveDays: [],
  rdvsOneMonth: [],
  rdvssixMonth: [],

  rdvsAboveFiveDays: [],

  rdvs: [],

  statutsRDV: [],
  statutsMobileRDV: [],
  callsForDisplay: { call: [], liste: [] ,listtotCallsOp:[]},
  researchJournal: [],
  demandeAffectation: [],
  salesForDisplayTv4:[],
  rdvForDisplayTv89:[],
  agendaInstallation:[],
};

// Calcule la tranche de temps (bucket) correspondant à une dateAppel.
// Doit rester synchronisé avec la logique de segmentation du backend.
const getDateBucket = (dateAppel) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const d = new Date(dateAppel);
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diff = Math.round((target - today) / 86400000);
  if (diff < 0)   return "outdated";
  if (diff === 0) return "today";
  if (diff === 1) return "tomorrow";
  if (diff === 2) return "twoDays";
  if (diff === 3) return "threeDays";
  if (diff === 4) return "fourDays";
  if (diff === 5) return "fiveDays";
  if (diff <= 35) return "oneMonth";
  return "sixMonth";
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CALL_ENDED:
      return {
        ...state,
        callEnded: action.payload,
      };
      return {
        ...state,
        failedUpload: action.payload,
      };

    case GET_CONTACTS_SOUS_CONTRAT_BY_ID:
      return {
        ...state,
        sousContrat: action.payload,
      };
    case GET_ACTIVITES:
      return {
        ...state,
        activites: action.payload,
      };

    case GET_APPEL_EMETTRE || UPDATE_DATE_APPEL_EMETTRE:
      return {
        ...state,
        appelAEmettresOutDated: action.payload.appelAEmettresOutDated,
        appelAEmettresToDay: action.payload.appelAEmettresToDay,
        appelAEmettresToMorrow: action.payload.appelAEmettresToMorrow,
        appelAEmettresTwoDays: action.payload.appelAEmettresTwoDays,
        appelAEmettresThreeDays: action.payload.appelAEmettresThreeDays,
        appelAEmettresFourDays: action.payload.appelAEmettresFourDays,
        appelAEmettresFiveDays: action.payload.appelAEmettresFiveDays,
        appelAEmettresOneMonth: action.payload.appelAEmettresOneMonth,
        appelAEmettresSixMonth: action.payload.appelAEmettresSixMonth,

        // appelAEmettresAboveFiveDays: action.payload.appelAEmettresAboveFiveDays,

        appelsEmettre: action.payload.appelAEmettres,
        appelAEmettresAssigned: action.payload.appelAEmettresAssigned,
        rdvCree: action.payload.rdvCree,
        appelAEmettresAssignedCategorised:
          action.payload.appelAEmettresAssignedCategorised,
        statutsAppelEmettre: action.payload.populatedContactStatus,
        statutsMobileAppelEmettre: action.payload.populatedContactStatusMobile,
      };
    case GET_RDV_AFFECTED_TO_USER:
      return {
        ...state,
        rdvsOutDated: action.payload.rdvsOutDated,
        rdvsToDay: action.payload.rdvsToDay,
        rdvsToMorrow: action.payload.rdvsToMorrow,
        rdvsTwoDays: action.payload.rdvsTwoDays,
        rdvsThreeDays: action.payload.rdvsThreeDays,
        rdvsFourDays: action.payload.rdvsFourDays,
        rdvsFiveDays: action.payload.rdvsFiveDays,
        rdvsOneMonth: action.payload.rdvsOneMonth,
        rdvssixMonth: action.payload.rdvssixMonth,
        // rdvsAboveFiveDays: action.payload.rdvsAboveFiveDays,

        rdvs: action.payload.rdvs,

        statutsRDV: action.payload.populatedContactStatus,
        statutsMobileRDV: action.payload.populatedContactStatusMobile,
      };

    case GET_RDV:
      return {
        ...state,
        rdvByUser: action.payload,
      };
    case GET_RDV_CREATED_BY_USER:
      return {
        ...state,
        rdvCreatedByUser: action.payload,
      };
    case GET_RDV_BY_CONTACT:
      return {
        ...state,
        rdvByContact: action.payload,
      };
    case ADD_RDV:
      return {
        ...state,
        rdvByContact: [action.payload, ...state.rdvByContact],
      };
    case UPDATE_RDV_BY_USER:
      return {
        ...state,
        rdvByUser: state.rdvByUser.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                dateAppel: action.payload.dateAppel,
                noteSup: action.payload.noteSup,
                noteTermine: action.payload.noteTermine,
                noteHistory: action.payload.noteHistory,
                noteAnnulation: action.payload.noteAnnulation,
                affected: action.payload.affected,
                etat: action.payload.etat,
                affectedTo: action.payload.affectedTo,
                important: action.payload.important,
                typeRDV: action.payload.typeRDV,
                etat: action.payload.etat,
                notified: action.payload.notified,
                affected: action.payload.affected,
              }
            : content
        ),
      };
    case UPDATE_RDV_BY_CONTACT:
      return {
        ...state,
        rdvByContact: state.rdvByContact.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                dateAppel: action.payload.dateAppel,
                noteSup: action.payload.noteSup,
                noteTermine: action.payload.noteTermine,
                noteHistory: action.payload.noteHistory,
                noteAnnulation: action.payload.noteAnnulation,
                affected: action.payload.affected,
                etat: action.payload.etat,
                affectedTo: action.payload.affectedTo,
                important: action.payload.important,
                typeRDV: action.payload.typeRDV,
                etat: action.payload.etat,
                notified: action.payload.notified,
                affected: action.payload.affected,
              }
            : content
        ),
      };

      case UPDATE_TIME_RDV: {
        const rdvUpdated  = action.payload;
        const rdvNewDate  = rdvUpdated.dateAppel;
        const rdvBucket   = getDateBucket(rdvNewDate);

        const rdvBucketMap = {
          outdated:   "rdvsOutDated",
          today:      "rdvsToDay",
          tomorrow:   "rdvsToMorrow",
          twoDays:    "rdvsTwoDays",
          threeDays:  "rdvsThreeDays",
          fourDays:   "rdvsFourDays",
          fiveDays:   "rdvsFiveDays",
          oneMonth:   "rdvsOneMonth",
          sixMonth:   "rdvssixMonth",
        };

        const rdvAllLists = [
          ...state.rdvsOutDated, ...state.rdvsToDay, ...state.rdvsToMorrow,
          ...state.rdvsTwoDays, ...state.rdvsThreeDays, ...state.rdvsFourDays,
          ...state.rdvsFiveDays, ...state.rdvsOneMonth, ...state.rdvssixMonth,
        ];
        const rdvFound    = rdvAllLists.find((c) => c._id === rdvUpdated._id);
        const rdvMoved    = rdvFound ? { ...rdvFound, dateAppel: rdvNewDate } : null;

        const rdvRemove   = (list) => list.filter((c) => c._id !== rdvUpdated._id);

        const rdvNewState = {
          ...state,
          rdvs:       state.rdvs.map((c)       => c._id === rdvUpdated._id ? { ...c, dateAppel: rdvNewDate } : c),
          rdvByUser:  state.rdvByUser.map((c)  => c._id === rdvUpdated._id ? { ...c, dateAppel: rdvNewDate } : c),
          rdvByContact: state.rdvByContact.map((c) => c._id === rdvUpdated._id ? { ...c, dateAppel: rdvNewDate } : c),
          rdvsOutDated:  rdvRemove(state.rdvsOutDated),
          rdvsToDay:     rdvRemove(state.rdvsToDay),
          rdvsToMorrow:  rdvRemove(state.rdvsToMorrow),
          rdvsTwoDays:   rdvRemove(state.rdvsTwoDays),
          rdvsThreeDays: rdvRemove(state.rdvsThreeDays),
          rdvsFourDays:  rdvRemove(state.rdvsFourDays),
          rdvsFiveDays:  rdvRemove(state.rdvsFiveDays),
          rdvsOneMonth:  rdvRemove(state.rdvsOneMonth),
          rdvssixMonth:  rdvRemove(state.rdvssixMonth),
        };

        const rdvTargetKey = rdvBucketMap[rdvBucket];
        if (rdvMoved && rdvTargetKey) {
          rdvNewState[rdvTargetKey] = [rdvMoved, ...rdvNewState[rdvTargetKey]];
        }

        return rdvNewState;
      }
    case GET_APPEL_EMETTRE_BY_CONTACT:
      return {
        ...state,
        appelsEmettreByContact: action.payload,
      };

    case ADD_APPEL_EMETTRE:
      return {
        ...state,
        appelsEmettreByContact: [
          action.payload,
          ...state.appelsEmettreByContact,
        ],
      };
    case DELETE_APPEL_EMETTRE:
      state.appelsEmettre.splice(
        state.appelsEmettre.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresOutDated.splice(
        state.appelAEmettresOutDated.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresToDay.splice(
        state.appelAEmettresToDay.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresToMorrow.splice(
        state.appelAEmettresToMorrow.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresTwoDays.splice(
        state.appelAEmettresTwoDays.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresThreeDays.splice(
        state.appelAEmettresThreeDays.findIndex(
          (e) => e._id === action.payload
        ),
        1
      );
      state.appelAEmettresFourDays.splice(
        state.appelAEmettresFourDays.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresFiveDays.splice(
        state.appelAEmettresFiveDays.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresOneMonth.splice(
        state.appelAEmettresOneMonth.findIndex((e) => e._id === action.payload),
        1
      );
      state.appelAEmettresSixMonth.splice(
        state.appelAEmettresSixMonth.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        appelsEmettre: state.appelsEmettre,
        appelAEmettresOutDated: state.appelAEmettresOutDated,
        appelAEmettresToDay: state.appelAEmettresToDay,
        appelAEmettresToMorrow: state.appelAEmettresToMorrow,
        appelAEmettresTwoDays: state.appelAEmettresTwoDays,
        appelAEmettresThreeDays: state.appelAEmettresThreeDays,
        appelAEmettresFourDays: state.appelAEmettresFourDays,
        appelAEmettresFiveDays: state.appelAEmettresFiveDays,
        appelAEmettresOneMonth:state.appelAEmettresOneMonth,
        appelAEmettresSixMonth:state.appelAEmettresSixMonth
        // appelAEmettresAboveFiveDays: state.appelAEmettresAboveFiveDays,
      };
    case DELETE_APPEL_EMETTRE_BY_CONTACT:
      state.appelsEmettreByContact.splice(
        state.appelsEmettreByContact.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        appelsEmettreByContact: state.appelsEmettreByContact,
      };
    // case UPDATE_APPEL_EMETTRE_NOTIFIED:
    //   state.appelAEmettresAssignedCategorised.splice(
    //     state.appelAEmettresAssignedCategorised.findIndex((e) => e._id === action.payload),
    //     1
    //   );
    //   return {
    //     ...state,
    //     appelAEmettresAssignedCategorised: state.appelAEmettresAssignedCategorised,
    //   };
    case GET_AFFECTED_CONTACTS:
      return {
        ...state,
        affectedContacts: action.payload,
      };
    case GET_AFFECTED_CONTACTS_ALARME:
      return {
        ...state,
        affectedContactsAlarme: action.payload,
      };

    case GET_AFFECTED_CONTACTS_MOBILE:
      return {
        ...state,
        affectedContactsMobile: action.payload,
      };
    case GET_SOUS_CONTRAT:
      return {
        ...state,
        sContrat: action.payload,
      };
    case GET_FUTURE_ECHEANCE:
      return {
        ...state,
        futureEcheance: action.payload,
      };
    case GET_FUTURE_BESOIN:
      return {
        ...state,
        futureBesoin: action.payload,
      };
    case GET_HORS_CIBLE:
      return {
        ...state,
        horsCible: action.payload,
      };

    case GET_SOUS_CONTRAT_ALARME:
      return {
        ...state,
        sContratAlarme: action.payload,
      };
    case GET_FUTURE_ECHEANCE_ALARME:
      return {
        ...state,
        futureEcheanceAlarme: action.payload,
      };
    case GET_FUTURE_BESOIN_ALARME:
      return {
        ...state,
        futureBesoinAlarme: action.payload,
      };
    case GET_KO_BUDGET_ALARME:
      return {
        ...state,
        koBudgetAlarme: action.payload,
      };
    case GET_KO_AUTORITE_ALARME:
      return {
        ...state,
        koAutoriteAlarme: action.payload,
      };
    case GET_KO_REFUS_ALARME:
      return {
        ...state,
        koRefusAlarme: action.payload,
      };
    case GET_PAS_INTERESSE_ALARME:
      return {
        ...state,
        pasInteresseAlarme: action.payload,
      };
    case GET_KO_AUTRE_ALARME:
      return {
        ...state,
        koAutreAlarme: action.payload,
      };

    case GET_SOUS_CONTRAT_MOBILE:
      return {
        ...state,
        sContratMobile: action.payload,
      };
    case GET_FUTURE_ECHEANCE_MOBILE:
      return {
        ...state,
        futureEcheanceMobile: action.payload,
      };
    case GET_FUTURE_BESOIN_MOBILE:
      return {
        ...state,
        futureBesoinMobile: action.payload,
      };
    case GET_KO_BUDGET_MOBILE:
      return {
        ...state,
        koBudgetMobile: action.payload,
      };

    case GET_KO_AUTORITE_MOBILE:
      return {
        ...state,
        koAutoriteMobile: action.payload,
      };

    case GET_KO_REFUS_MOBILE:
      return {
        ...state,
        koRefusMobile: action.payload,
      };
    case GET_PAS_INTERESSE_MOBILE:
      return {
        ...state,
        pasInteresseMobile: action.payload,
      };
    case GET_KO_AUTRE_MOBILE:
      return {
        ...state,
        koAutreMobile: action.payload,
      };



     // UPDATE_TIME_APPEL_EMETTRE

     case UPDATE_TIME_APPEL_EMETTRE: {
        const aeUpdated  = action.payload;
        const aeNewDate  = aeUpdated.dateAppel;
        const aeBucket   = getDateBucket(aeNewDate);

        const aeBucketMap = {
          outdated:  "appelAEmettresOutDated",
          today:     "appelAEmettresToDay",
          tomorrow:  "appelAEmettresToMorrow",
          twoDays:   "appelAEmettresTwoDays",
          threeDays: "appelAEmettresThreeDays",
          fourDays:  "appelAEmettresFourDays",
          fiveDays:  "appelAEmettresFiveDays",
          oneMonth:  "appelAEmettresOneMonth",
          sixMonth:  "appelAEmettresSixMonth",
        };

        const aeAllLists = [
          ...state.appelAEmettresOutDated, ...state.appelAEmettresToDay,
          ...state.appelAEmettresToMorrow, ...state.appelAEmettresTwoDays,
          ...state.appelAEmettresThreeDays, ...state.appelAEmettresFourDays,
          ...state.appelAEmettresFiveDays, ...state.appelAEmettresOneMonth,
          ...state.appelAEmettresSixMonth,
        ];
        const aeFound    = aeAllLists.find((c) => c._id === aeUpdated._id);
        const aeMoved    = aeFound ? { ...aeFound, dateAppel: aeNewDate } : null;

        const aeRemove   = (list) => list.filter((c) => c._id !== aeUpdated._id);

        const aeNewState = {
          ...state,
          appelsEmettre:          state.appelsEmettre.map((c) => c._id === aeUpdated._id ? { ...c, dateAppel: aeNewDate } : c),
          appelAEmettresOutDated:  aeRemove(state.appelAEmettresOutDated),
          appelAEmettresToDay:     aeRemove(state.appelAEmettresToDay),
          appelAEmettresToMorrow:  aeRemove(state.appelAEmettresToMorrow),
          appelAEmettresTwoDays:   aeRemove(state.appelAEmettresTwoDays),
          appelAEmettresThreeDays: aeRemove(state.appelAEmettresThreeDays),
          appelAEmettresFourDays:  aeRemove(state.appelAEmettresFourDays),
          appelAEmettresFiveDays:  aeRemove(state.appelAEmettresFiveDays),
          appelAEmettresOneMonth:  aeRemove(state.appelAEmettresOneMonth),
          appelAEmettresSixMonth:  aeRemove(state.appelAEmettresSixMonth),
        };

        const aeTargetKey = aeBucketMap[aeBucket];
        if (aeMoved && aeTargetKey) {
          aeNewState[aeTargetKey] = [aeMoved, ...aeNewState[aeTargetKey]];
        }

        return aeNewState;
      }
   














    case UPDATE_TIME_BULK_APPEL_EMETTRE: {
      const bulkAeIds    = new Set(action.payload.ids.map((id) => id.toString()));
      const bulkAeDate   = action.payload.dateAppel;
      const bulkAeBucket = getDateBucket(bulkAeDate);

      const bulkAeBucketMap = {
        outdated:  "appelAEmettresOutDated",
        today:     "appelAEmettresToDay",
        tomorrow:  "appelAEmettresToMorrow",
        twoDays:   "appelAEmettresTwoDays",
        threeDays: "appelAEmettresThreeDays",
        fourDays:  "appelAEmettresFourDays",
        fiveDays:  "appelAEmettresFiveDays",
        oneMonth:  "appelAEmettresOneMonth",
        sixMonth:  "appelAEmettresSixMonth",
      };

      const bulkAeAllLists = [
        ...state.appelAEmettresOutDated, ...state.appelAEmettresToDay,
        ...state.appelAEmettresToMorrow, ...state.appelAEmettresTwoDays,
        ...state.appelAEmettresThreeDays, ...state.appelAEmettresFourDays,
        ...state.appelAEmettresFiveDays, ...state.appelAEmettresOneMonth,
        ...state.appelAEmettresSixMonth,
      ];
      const bulkAeMoved = bulkAeAllLists
        .filter((c) => bulkAeIds.has(c._id.toString()))
        .map((c) => ({ ...c, dateAppel: bulkAeDate }));

      const bulkAeRemove = (list) => list.filter((c) => !bulkAeIds.has(c._id.toString()));

      const bulkAeNewState = {
        ...state,
        appelsEmettre:          state.appelsEmettre.map((c) => bulkAeIds.has(c._id.toString()) ? { ...c, dateAppel: bulkAeDate } : c),
        appelAEmettresOutDated:  bulkAeRemove(state.appelAEmettresOutDated),
        appelAEmettresToDay:     bulkAeRemove(state.appelAEmettresToDay),
        appelAEmettresToMorrow:  bulkAeRemove(state.appelAEmettresToMorrow),
        appelAEmettresTwoDays:   bulkAeRemove(state.appelAEmettresTwoDays),
        appelAEmettresThreeDays: bulkAeRemove(state.appelAEmettresThreeDays),
        appelAEmettresFourDays:  bulkAeRemove(state.appelAEmettresFourDays),
        appelAEmettresFiveDays:  bulkAeRemove(state.appelAEmettresFiveDays),
        appelAEmettresOneMonth:  bulkAeRemove(state.appelAEmettresOneMonth),
        appelAEmettresSixMonth:  bulkAeRemove(state.appelAEmettresSixMonth),
      };

      const bulkAeTargetKey = bulkAeBucketMap[bulkAeBucket];
      if (bulkAeTargetKey && bulkAeMoved.length > 0) {
        bulkAeNewState[bulkAeTargetKey] = [...bulkAeMoved, ...bulkAeNewState[bulkAeTargetKey]];
      }

      return bulkAeNewState;
    }

    case UPDATE_TIME_BULK_RDV: {
      const bulkRdvIds    = new Set(action.payload.ids.map((id) => id.toString()));
      const bulkRdvDate   = action.payload.dateAppel;
      const bulkRdvBucket = getDateBucket(bulkRdvDate);

      const bulkRdvBucketMap = {
        outdated:  "rdvsOutDated",
        today:     "rdvsToDay",
        tomorrow:  "rdvsToMorrow",
        twoDays:   "rdvsTwoDays",
        threeDays: "rdvsThreeDays",
        fourDays:  "rdvsFourDays",
        fiveDays:  "rdvsFiveDays",
        oneMonth:  "rdvsOneMonth",
        sixMonth:  "rdvssixMonth",
      };

      const bulkRdvAllLists = [
        ...state.rdvsOutDated, ...state.rdvsToDay, ...state.rdvsToMorrow,
        ...state.rdvsTwoDays, ...state.rdvsThreeDays, ...state.rdvsFourDays,
        ...state.rdvsFiveDays, ...state.rdvsOneMonth, ...state.rdvssixMonth,
      ];
      const bulkRdvMoved = bulkRdvAllLists
        .filter((c) => bulkRdvIds.has(c._id.toString()))
        .map((c) => ({ ...c, dateAppel: bulkRdvDate }));

      const bulkRdvRemove = (list) => list.filter((c) => !bulkRdvIds.has(c._id.toString()));

      const bulkRdvNewState = {
        ...state,
        rdvs:        state.rdvs.map((c)       => bulkRdvIds.has(c._id.toString()) ? { ...c, dateAppel: bulkRdvDate } : c),
        rdvByUser:   state.rdvByUser.map((c)  => bulkRdvIds.has(c._id.toString()) ? { ...c, dateAppel: bulkRdvDate } : c),
        rdvByContact: state.rdvByContact.map((c) => bulkRdvIds.has(c._id.toString()) ? { ...c, dateAppel: bulkRdvDate } : c),
        rdvsOutDated:  bulkRdvRemove(state.rdvsOutDated),
        rdvsToDay:     bulkRdvRemove(state.rdvsToDay),
        rdvsToMorrow:  bulkRdvRemove(state.rdvsToMorrow),
        rdvsTwoDays:   bulkRdvRemove(state.rdvsTwoDays),
        rdvsThreeDays: bulkRdvRemove(state.rdvsThreeDays),
        rdvsFourDays:  bulkRdvRemove(state.rdvsFourDays),
        rdvsFiveDays:  bulkRdvRemove(state.rdvsFiveDays),
        rdvsOneMonth:  bulkRdvRemove(state.rdvsOneMonth),
        rdvssixMonth:  bulkRdvRemove(state.rdvssixMonth),
      };

      const bulkRdvTargetKey = bulkRdvBucketMap[bulkRdvBucket];
      if (bulkRdvTargetKey && bulkRdvMoved.length > 0) {
        bulkRdvNewState[bulkRdvTargetKey] = [...bulkRdvMoved, ...bulkRdvNewState[bulkRdvTargetKey]];
      }

      return bulkRdvNewState;
    }

    // Reprogrammation appels selon agenda: re-bucket par élément (chaque item peut aller dans un bucket différent).
    case UPDATE_TIME_BULK_APPEL_EMETTRE_AGENDA: {
      const agendaAeMap = new Map(
        (action.payload.updates || []).map((u) => [String(u._id), u.dateAppel])
      );
      const agendaAeBucketMap = {
        outdated:  "appelAEmettresOutDated",
        today:     "appelAEmettresToDay",
        tomorrow:  "appelAEmettresToMorrow",
        twoDays:   "appelAEmettresTwoDays",
        threeDays: "appelAEmettresThreeDays",
        fourDays:  "appelAEmettresFourDays",
        fiveDays:  "appelAEmettresFiveDays",
        oneMonth:  "appelAEmettresOneMonth",
        sixMonth:  "appelAEmettresSixMonth",
      };
      const agendaAeAllLists = [
        ...state.appelAEmettresOutDated, ...state.appelAEmettresToDay,
        ...state.appelAEmettresToMorrow, ...state.appelAEmettresTwoDays,
        ...state.appelAEmettresThreeDays, ...state.appelAEmettresFourDays,
        ...state.appelAEmettresFiveDays, ...state.appelAEmettresOneMonth,
        ...state.appelAEmettresSixMonth,
      ];
      const agendaAeMoved = agendaAeAllLists
        .filter((c) => agendaAeMap.has(String(c._id)))
        .map((c) => ({ ...c, dateAppel: agendaAeMap.get(String(c._id)) }));

      const agendaAeRemove = (list) => list.filter((c) => !agendaAeMap.has(String(c._id)));

      const agendaAeNewState = {
        ...state,
        appelsEmettre: state.appelsEmettre.map((c) =>
          agendaAeMap.has(String(c._id)) ? { ...c, dateAppel: agendaAeMap.get(String(c._id)) } : c
        ),
        appelAEmettresOutDated:  agendaAeRemove(state.appelAEmettresOutDated),
        appelAEmettresToDay:     agendaAeRemove(state.appelAEmettresToDay),
        appelAEmettresToMorrow:  agendaAeRemove(state.appelAEmettresToMorrow),
        appelAEmettresTwoDays:   agendaAeRemove(state.appelAEmettresTwoDays),
        appelAEmettresThreeDays: agendaAeRemove(state.appelAEmettresThreeDays),
        appelAEmettresFourDays:  agendaAeRemove(state.appelAEmettresFourDays),
        appelAEmettresFiveDays:  agendaAeRemove(state.appelAEmettresFiveDays),
        appelAEmettresOneMonth:  agendaAeRemove(state.appelAEmettresOneMonth),
        appelAEmettresSixMonth:  agendaAeRemove(state.appelAEmettresSixMonth),
      };
      // Réinsérer chaque item dans son bucket calculé selon sa propre date.
      agendaAeMoved.forEach((item) => {
        const key = agendaAeBucketMap[getDateBucket(item.dateAppel)];
        if (key) agendaAeNewState[key] = [item, ...agendaAeNewState[key]];
      });
      return agendaAeNewState;
    }

    // Reprogrammation RDV selon agenda: re-bucket par élément.
    case UPDATE_TIME_BULK_RDV_AGENDA: {
      const agendaRdvMap = new Map(
        (action.payload.updates || []).map((u) => [String(u._id), u.dateAppel])
      );
      const agendaRdvBucketMap = {
        outdated:  "rdvsOutDated",
        today:     "rdvsToDay",
        tomorrow:  "rdvsToMorrow",
        twoDays:   "rdvsTwoDays",
        threeDays: "rdvsThreeDays",
        fourDays:  "rdvsFourDays",
        fiveDays:  "rdvsFiveDays",
        oneMonth:  "rdvsOneMonth",
        sixMonth:  "rdvssixMonth",
      };
      const agendaRdvAllLists = [
        ...state.rdvsOutDated, ...state.rdvsToDay, ...state.rdvsToMorrow,
        ...state.rdvsTwoDays, ...state.rdvsThreeDays, ...state.rdvsFourDays,
        ...state.rdvsFiveDays, ...state.rdvsOneMonth, ...state.rdvssixMonth,
      ];
      const agendaRdvMoved = agendaRdvAllLists
        .filter((c) => agendaRdvMap.has(String(c._id)))
        .map((c) => ({ ...c, dateAppel: agendaRdvMap.get(String(c._id)) }));

      const agendaRdvRemove = (list) => list.filter((c) => !agendaRdvMap.has(String(c._id)));

      const agendaRdvNewState = {
        ...state,
        rdvs:        state.rdvs.map((c) =>
          agendaRdvMap.has(String(c._id)) ? { ...c, dateAppel: agendaRdvMap.get(String(c._id)) } : c
        ),
        rdvByUser:   state.rdvByUser.map((c) =>
          agendaRdvMap.has(String(c._id)) ? { ...c, dateAppel: agendaRdvMap.get(String(c._id)) } : c
        ),
        rdvByContact: state.rdvByContact.map((c) =>
          agendaRdvMap.has(String(c._id)) ? { ...c, dateAppel: agendaRdvMap.get(String(c._id)) } : c
        ),
        rdvsOutDated:  agendaRdvRemove(state.rdvsOutDated),
        rdvsToDay:     agendaRdvRemove(state.rdvsToDay),
        rdvsToMorrow:  agendaRdvRemove(state.rdvsToMorrow),
        rdvsTwoDays:   agendaRdvRemove(state.rdvsTwoDays),
        rdvsThreeDays: agendaRdvRemove(state.rdvsThreeDays),
        rdvsFourDays:  agendaRdvRemove(state.rdvsFourDays),
        rdvsFiveDays:  agendaRdvRemove(state.rdvsFiveDays),
        rdvsOneMonth:  agendaRdvRemove(state.rdvsOneMonth),
        rdvssixMonth:  agendaRdvRemove(state.rdvssixMonth),
      };
      agendaRdvMoved.forEach((item) => {
        const key = agendaRdvBucketMap[getDateBucket(item.dateAppel)];
        if (key) agendaRdvNewState[key] = [item, ...agendaRdvNewState[key]];
      });
      return agendaRdvNewState;
    }

    case UPDATE_APPEL_EMETTRE:
      return {
        ...state,
        appelsEmettre: state.appelsEmettre.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresOutDated: state.appelAEmettresOutDated.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresToDay: state.appelAEmettresToDay.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresToMorrow: state.appelAEmettresToMorrow.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresTwoDays: state.appelAEmettresTwoDays.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresThreeDays: state.appelAEmettresThreeDays.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresFourDays: state.appelAEmettresFourDays.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresFiveDays: state.appelAEmettresFiveDays.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresOneMonth: state.appelAEmettresOneMonth.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
        appelAEmettresSixMonth: state.appelAEmettresSixMonth.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                dateAppel: action.payload.dateAppel,
                note: action.payload.note,
                important: action.payload.important,
                raison: action.payload.raison,
                creatorId: action.payload.creatorId,
                contactId: action.payload.contactId,
                typeAppel: action.payload.typeAppel,
                typeRDV: action.payload.typeRDV,
                approche: action.payload.approche,
                dateFin: action.payload.dateFin,
                assignedId: action.payload.assignedId,
                etat: action.payload.etat,
              }
            : content
        ),
       
      };
    case UPDATE_APPEL_EMETTRE_BY_CONTACT:
      return {
        ...state,
        appelsEmettreByContact: state.appelsEmettreByContact
          .map((content) =>
            content._id === action.payload._id
              ? {
                  ...content,

                  dateAppel: action.payload.dateAppel,
                  note: action.payload.note,
                  important: action.payload.important,
                  raison: action.payload.raison,
                  creatorId: action.payload.creatorId,
                  contactId: action.payload.contactId,
                  typeAppel: action.payload.typeAppel,
                  typeRDV: action.payload.typeRDV,
                  approche: action.payload.approche,
                  dateFin: action.payload.dateFin,

                  etat: action.payload.etat,
                }
              : content
          )
          .filter((x) => x.etat === "en cours"),
      };
    case GET_ETAPES:
      return {
        ...state,
        etapes: action.payload,
      };
    case GET_CALLS:
      return {
        ...state,
        calls: action.payload,
      };
    case GET_CALLS_FOR_DISPLAY:
      return {
        ...state,
        callsForDisplay: action.payload,
      };

    case GET_SALES_FOR_DISPLAY:
      return{
        ...state,
        salesForDisplayTv4:action.payload

      } 
        case GET_RDV_FOR_DISPLAY:
      return{
        ...state,
        rdvForDisplayTv89:action.payload

      } 
    case  GET_AGENDA_INSTALLATION:
        return{
          ...state,
          agendaInstallation:action.payload
  
        } 



    case GET_CALL_ID:
      return {
        ...state,
        updatedCall: action.payload,
      };
    case GET_CALLS_CHIP:
      return {
        ...state,
        callsChip: action.payload,
      };
    case GET_CALLS_CHIP_COUNTS:
      return {
        ...state,
        callsChip: { calls: state.callsChip.calls, ...action.payload },
      };
    case GET_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      };

  // Chargement complet : remplace la liste principale et efface tout résultat
  // de recherche précédent (retour au mode liste complète).
  case GET_CONTACTS_HORSCIRCUIT_ALARME:
    return {
      ...state,
      contactsHorsCircuit: action.payload,
      contactsHorsCircuitSearch: null,
    };

  // Recherche par numéro : stocke les résultats dans un champ dédié sans
  // toucher à la liste principale. null = pas de recherche active.
  case MERGE_CONTACTS_HORS_CIRCUIT: {
    const incoming = Array.isArray(action.payload) ? action.payload : [action.payload];
    const filtered = incoming.filter(
      (c) =>
        c.horsCircuit === "Oui" ||
        c.horsCircuitMobile === "Oui" ||
        c.horsCircuitInternet === "Oui"
    );
    return { ...state, contactsHorsCircuitSearch: filtered };
  }

  // Réintégration partielle : met à jour les flags dans les DEUX listes puis
  // retire le contact uniquement s'il n'est plus hors circuit sur aucune approche.
  case UPDATE_CONTACTS_HORSCIRCUIT_ALARME: {
    const syncList = (list) => {
      if (!Array.isArray(list)) return list;
      return list
        .map((c) =>
          c._id?.toString() === action.payload._id?.toString()
            ? { ...c, ...action.payload }
            : c
        )
        .filter(
          (c) =>
            c.horsCircuit === "Oui" ||
            c.horsCircuitMobile === "Oui" ||
            c.horsCircuitInternet === "Oui"
        );
    };
    return {
      ...state,
      contactsHorsCircuit: syncList(state.contactsHorsCircuit),
      contactsHorsCircuitSearch: syncList(state.contactsHorsCircuitSearch),
    };
  }

  // Synchronisation via l'Exit Rule : même logique update + filtre sur les deux listes.
  case UPDATE_CONTACT: {
    const syncList = (list) => {
      if (!Array.isArray(list)) return list;
      return list
        .map((c) =>
          c._id?.toString() === action.payload._id?.toString()
            ? { ...c, ...action.payload }
            : c
        )
        .filter(
          (c) =>
            c.horsCircuit === "Oui" ||
            c.horsCircuitMobile === "Oui" ||
            c.horsCircuitInternet === "Oui"
        );
    };
    return {
      ...state,
      contactsHorsCircuit: syncList(state.contactsHorsCircuit),
      contactsHorsCircuitSearch: syncList(state.contactsHorsCircuitSearch),
    };
  }
      
    case GET_CONTACTS_NOT_AFFECTED:
      return {
        ...state,
        contactsNotAffected: action.payload,
      };
    case GET_CONTACTS_NOT_AFFECTED_ALARME:
      return {
        ...state,
        contactsNotAffectedAlarme: action.payload,
      };
    case GET_CONTACTS_NOT_AFFECTED_MOBILE:
      return {
        ...state,
        contactsNotAffectedMobile: action.payload,
      };
    case GET_VENTES:
      return {
        ...state,
        ventes: action.payload,
      };
    case UPDATE_ETAPE:
      return {
        ...state,
        etapes: state.etapes.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                libelle: action.payload.libelle,
                valideurs: action.payload.valideurs,
                lecteurs: action.payload.lecteurs,
                modificateurs: action.payload.modificateurs,
              }
            : content
        ),
      };

    case GET_NOTES:
      return {
        ...state,
        notesDynamiques: action.payload,
      };

    case UPDATE_NOTE:
      return {
        ...state,
        notesDynamiques: state.notesDynamiques.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,
                content: action.payload.content,
                libelle: action.payload.libelle,
              }
            : content
        ),
      };

    case ADD_NOTE:
      return {
        ...state,
        notesDynamiques: [action.payload, ...state.notesDynamiques],
        // notesDynamiques: [ ...state.notesDynamiques],
      };
    case DELETE_NOTE:
      state.notesDynamiques.splice(
        state.notesDynamiques.findIndex((e) => e._id === action.payload),
        1
      );
      return {
        ...state,
        notesDynamiques: state.notesDynamiques,
      };

    case GET_VENTE_BY_ID:
      return {
        ...state,
        venteByID: action.payload,
      };

    // PipeLine
    case GET_PIPELINE_CONTACT:
      return {
        ...state,
        pipelineLeads: action.payload,
      };
    case GET_PIPELINE_CONTACT_BY_USER:
      return {
        ...state,
        pipelineLeads: action.payload,
      };
    case GET_PIPELINE_CONTACT_MOBILE:
      return {
        ...state,
        pipelineLeadsMobile: action.payload,
      };
    case GET_PIPELINE_CONTACT_MOBILE_BY_USER:
      return {
        ...state,
        pipelineLeadsMobile: action.payload,
      };
    case MODIFY_STATUT_PIPELINE:
      return {
        ...state,

        pipelineLeads: state.pipelineLeads.map((content) =>
          content.adresseId._id === action.payload.adresseId
            ? {
                ...content,
                pipelineLeads: [action.payload, ...content.pipelineLeads],
              }
            : content
        ),
      };
    case MODIFY_STATUT_PIPELINE_MOBILE:
      return {
        ...state,

        pipelineLeadsMobile: state.pipelineLeadsMobile.map((content) =>
          content.contactId._id === action.payload.contactId
            ? {
                ...content,
                pipelineLeadsMobile: [
                  action.payload,
                  ...content.pipelineLeadsMobile,
                ],
              }
            : content
        ),
      };
    case GET_PIPELINE_CONTACT_AFFECTED:
      return {
        ...state,
        pipelineLeadsAffected: action.payload,
      };
    case GET_PIPELINE_CONTACT_AFFECTED_BY_USER:
      return {
        ...state,
        pipelineLeadsAffected: action.payload,
      };
    case GET_PIPELINE_CONTACT_AFFECTED_MOBILE:
      return {
        ...state,
        pipelineLeadsAffectedMobile: action.payload,
      };
    case GET_PIPELINE_CONTACT_AFFECTED_MOBILE_BY_USER:
      return {
        ...state,
        pipelineLeadsAffectedMobile: action.payload,
      };

    case GET_RH_TIMELINE:
      return {
        ...state,
        RHTimeline: action.payload,
      };

    case ACCEPT_AFFECTED_CONTACT:
      return {
        ...state,
        affectedContacts: state.affectedContacts.map((content) =>
          content._id === action.payload.populatedContact._id
            ? {
                ...content,
                lastElemAlarme: action.payload.lastElemAlarme,
                lastElemMobile: action.payload.lastElemMobile,
              }
            : content
        ),
      };
    case GET_RESEARCH_JOURNAL:
      return {
        ...state,
        researchJournal: action.payload,
      };
    case GET_DEMANDE_AFFECTAION:
      return {
        ...state,
        demandeAffectation: action.payload,
      };
    case UPDATE_DEMANDE_AFFECTAION:
      return {
        ...state,

        demandeAffectation: state.demandeAffectation.map((content) =>
          content._id === action.payload._id
            ? {
                ...content,

                etat: action.payload.etat,
              }
            : content
        ),
      };
    default:
      return state;
  }
}
